<template>
  <div>
    <BaseListPage
        :name="name"
        :base-query="baseQuery"
        :store-path="storePath"
        :response-path="responsePath"
        :save-key="saveKey"
        :table-set-list="tableSetList"
        :table-data-list="sortedList"
        :min-column-width="'120px'"
        :async-render="true"
        :show-pagination="true"
        :is-max-get-count="false"
        :sum-table-list="sumTableRows"
        :sum-display-list="sumDisplayRows"
        title="販売売上レポート(デジタル)：期間分析(商品別)"
        title-class="sales-header"
        icon="report">
      <span
          slot="headerAction"
          class="action_button">
        <span>
          <el-button
              id="displayTax"
              class="displayTax"
              size="small"
              @click="displayTax">
            {{ displayTax.textContent }}税込計算
          </el-button>
        </span>
        <el-dropdown
            v-show="showActionList">
          <el-button size="small">
            アクション
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu
              slot="dropdown"
              class="header-action-menu">
            <ToDownload
                ref="download"
                page-key="sales_digital_product_list"
                :conditions="conditions"
                :keyword="searchKeyword"
                :is-and-search="isAndSearch" />
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </BaseListPage>
  </div>
</template>

<script>
/* eslint-disable no-console */
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import * as define from '@/define'
import * as query from '@/queries/sales'
import x from '@/components/mixins/mixin'
import orderUtil from '@/components/mixins/orderUtil'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseListPage from '@/components/pages/report/sales/SalesBaseListPage'
import ToDownload from '@/components/organisms/ToDownload'

export default {
  name: 'SalesProductDigitalList',
  components: {
    BaseListPage,
    ToDownload
  },
  mixins: [ x, orderUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      isDisplaySelectDialog: false,
      localIsParentLoaded: false,
      showActionList: false,
      isDisplayTax: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.SalesProductDigital.listIndex,
      tableSetList: (state) => state.SalesProductDigital.tableSetList,
      searchKeyword: (state) => state.SalesProductDigital.searchKeyword || '',
      isAndSearch: (state) => state.SalesProductDigital.isAndSearch || false,
      conditions: (state) => state.SalesProductDigital.searchConditions || {},
      tdLists: (state) => state.SalesProductDigital.tdLists,
      sites: (state) => state.sites
    }),
    ...mapGetters({
      getSortedList: 'sortedList',
      getServiceSiteConfig: 'getServiceSiteConfig',
      searchConditions: 'searchConditions'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'SalesProductDigitalList'
    },
    storePath () {
      return 'SalesProductDigital'
    },
    saveKey () {
      return 'salesProductDigitalCondition'
    },
    responsePath () {
      return 'data.salesProductLists.edges'
    },
    returnPath () {
      return '/report/salesProductDigital'
    },
    baseQuery () {
      return 'query { ' + query.GRAPH_QL_QUERY_SALES_PRODUCT_DIGITAL +
       query.GRAPH_QL_QUERY_SALES_PRODUCT_LIST +
       '}}'
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      const taxMode = (this.isDisplayTax ? 'Gross' : 'Net')
      const productPagesflg = this.$isFunctionShown(define.PermissionKeys.PRODUCT) &&
        this.$isFunctionShown(define.PermissionKeys.Product.DETAIL)
      const returnValue = [
        {
          itemKey: 'groupUnitMonth', isAvailable: false, isActive: false,
          type: 'String', label: '月', path: 'node.Month', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.GROUPBY_MONTH
        },
        {
          itemKey: 'groupUnitDay', isAvailable: false, isActive: false,
          type: 'String', label: '日', path: 'node.Day', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.GROUPBY_DAY
        },
        {
          itemKey: 'groupUnitHour', isAvailable: false, isActive: false,
          type: 'String', label: '時', path: 'node.Hour', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.GROUPBY_HOUR
        },
        {
          itemKey: 'groupUnitPaymentMethod', isAvailable: false, isActive: false,
          type: 'String', label: '支払方法', path: 'node.PaymentMethod', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.GROUPBY_PAYMENTMETHOD
        },
        {
          itemKey: 'groupUnitSite', isAvailable: false, isActive: false,
          type: 'String', label: 'サイト', path: 'node.Site', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.GROUPBY_SITE
        },
        {
          itemKey: 'sku_code', isAvailable: true, isActive: true,
          type: 'String', label: 'SKUコード', path: 'node.skuCode', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.SKU_CODE,
          elementType: productPagesflg ? ELEMENT_TYPE.LINK : ELEMENT_TYPE.INPUT,
          class: 'visitedlinkNoChangeColor', linkKey: 'node.productUuid', linkPath: '/product/',
          onLinkClick: (key, keyPath) => { this.$_mixin_onLinkClick(-1, 'Product') }
        },
        {
          itemKey: 'jan_code', isAvailable: true, isActive: true,
          type: 'String', label: 'JANコード', path: 'node.janCode', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.JAN_CODE
        },
        {
          itemKey: 'sku_name', isAvailable: true, isActive: true,
          type: 'String', label: 'SKU表示名', path: 'node.skuName', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.SKU_NAME
        },
        {
          itemKey: 'product_code', isAvailable: true, isActive: true,
          type: 'String', label: '商品コード', path: 'node.productCode', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.PRODUCT_CODE,
          elementType: productPagesflg ? ELEMENT_TYPE.LINK : ELEMENT_TYPE.INPUT,
          class: 'visitedlinkNoChangeColor', linkKey: 'node.productUuid', linkPath: '/product/',
          onLinkClick: (key, keyPath) => { this.$_mixin_onLinkClick(-1, 'Product') }
        },
        {
          itemKey: 'product_name', isAvailable: true, isActive: true,
          type: 'String', label: '商品名', path: 'node.productName', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.PRODUCT_NAME
        },
        {
          itemKey: 'variation_name', isAvailable: true, isActive: true,
          type: 'String', label: 'バリエーション名', path: 'node.variationName',
          sortable: 'custom', width: 160,
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.VARIATION_NAME
        },
        {
          itemKey: 'artist_code', isAvailable: true, isActive: true,
          type: 'String', label: 'アーティストコード', path: 'node.artistCode',
          sortable: 'custom', width: 180,
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.ARTIST_CODE
        },
        {
          itemKey: 'artist_name', type: 'String', label: 'アーティスト名', path: 'node.artistName',
          sortable: 'custom', width: 150,
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.ARTIST_NAME
        },
        {
          itemKey: 'unit_price', isAvailable: true, isActive: true,
          type: 'Number', label: this.isDisplayTax ? '単価(税込)' : '単価(税抜)',
          path: 'node.unitPrice' + taxMode, sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.UNIT_PRICE
        },
        {
          itemKey: 'order_cnt', type: 'String', label: '注文件数', path: 'node.orderCnt',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.ORDER_CNT
        },
        {
          itemKey: 'quantity', type: 'String', label: '数量', path: 'node.quantity',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.ORDER_QUANTITY
        },
        {
          itemKey: 'amount', type: 'Number', label: this.isDisplayTax ? '金額(税込)' : '金額(税抜)',
          path: 'node.amount' + taxMode, sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.ORDER_AMOUNT
        },
        {
          itemKey: 'return_cnt', type: 'String', label: '返品件数', path: 'node.returnCnt',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.RETURN_CNT
        },
        {
          itemKey: 'return_qty', type: 'String', label: '返品数量', path: 'node.returnQty',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.RETURN_QUANTITY
        },
        {
          itemKey: 'return_amount', type: 'Number', label: this.isDisplayTax ? '返品金額(税込)' : '返品金額(税抜)',
          path: 'node.returnAmount' + taxMode, sortable: 'custom', class: 'right', width: 160,
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.RETURN_AMOUNT
        },
        {
          itemKey: 'available_quantity', isAvailable: true, isActive: true,
          type: 'String', label: '販売可能数', path: 'node.availableQuantity',
          sortable: 'custom', class: 'right', width: 130,
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.AVAILABLE_QUANTITY
        }
      ]
      return returnValue.sort((a, b) => a.displayOrder < b.displayOrder ? -1 : 1)
    },
    sumTableRows () {
      return this.sumData(this.sortedList)
    },
    sumDisplayRows () {
      const sumLabels = [
        {
          itemKey: 'unit_price', isAvailable: true, isActive: true, width: 140,
          type: 'Number', label: this.isDisplayTax ? '合計 単価(税込)' : '合計 単価(税抜)', path: 'sumUnitPrice',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.UNIT_PRICE
        },
        {
          itemKey: 'order_cnt', width: null,
          type: 'String', label: '合計 注文件数', path: 'sumOrderCnt',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.ORDER_CNT
        },
        {
          itemKey: 'quantity', width: null,
          type: 'String', label: '合計 数量', path: 'sumQuantity',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.ORDER_QUANTITY
        },
        {
          itemKey: 'amount', width: 140,
          type: 'Number', label: this.isDisplayTax ? '合計 金額(税込)' : '合計 金額(税抜)', path: 'sumAmount',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.ORDER_AMOUNT
        },
        {
          itemKey: 'return_cnt', width: null,
          type: 'String', label: '合計 返品件数', path: 'sumReturnCnt',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.RETURN_CNT
        },
        {
          itemKey: 'return_qty', width: null,
          type: 'String', label: '合計 返品数量', path: 'sumReturnQty',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.RETURN_QUANTITY
        },
        {
          itemKey: 'return_amount', width: 170,
          type: 'Number', label: this.isDisplayTax ? '合計 返品金額(税込)' : '合計 返品金額(税抜)', path: 'sumReturnAmount',
          funcId: define.PermissionKeys.Report.Sales.Sales_product_list.RETURN_AMOUNT
        }
      ]
      return sumLabels
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      // ダウンロードが可能のとき、アクションを表示
      const tempThisComponent = this
      setTimeout(() => {
        tempThisComponent.showActionList = this.$isFunctionShown(_.get(tempThisComponent.$refs, 'download.toDownload.funcId', ''))
      }, 1)

      this.$store.dispatch({
        type: 'set',
        states: {
          'SalesProductDigital/tableSetList': this._tableSetList
        }
      })
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  beforeUpdate () {
    const labelMonth = this.tableSetList.filter(row => row.itemKey === 'groupUnitMonth')
    const labelDay = this.tableSetList.filter(row => row.itemKey === 'groupUnitDay')
    const labelHour = this.tableSetList.filter(row => row.itemKey === 'groupUnitHour')
    const labelPaymentMethod = this.tableSetList.filter(row => row.itemKey === 'groupUnitPaymentMethod')
    const labelSite = this.tableSetList.filter(row => row.itemKey === 'groupUnitSite')

    // グループ単位（月、日、支払方法、サイト）列の表示切替
    // 検索条件の指定により、画面上の検索条件を修正後、税込計算ボタン押下で更新され、項目が表示される。
    // ただし、GraphQL側で取得していないため、項目値がブランクになる。
    labelMonth[0].isAvailable = this.conditions['groupUnit'].value.includes('0')
    labelMonth[0].isActive = this.conditions['groupUnit'].value.includes('0')
    labelDay[0].isAvailable = this.conditions['groupUnit'].value.includes('1')
    labelDay[0].isActive = this.conditions['groupUnit'].value.includes('1')
    labelHour[0].isAvailable = this.conditions['groupUnit'].value.includes('2')
    labelHour[0].isActive = this.conditions['groupUnit'].value.includes('2')
    labelPaymentMethod[0].isAvailable = this.conditions['groupUnit'].value.includes('3')
    labelPaymentMethod[0].isActive = this.conditions['groupUnit'].value.includes('3')
    labelSite[0].isAvailable = this.conditions['groupUnit'].value.includes('4')
    labelSite[0].isActive = this.conditions['groupUnit'].value.includes('4')

    // SKUコード、JANコード、SKU表示名、商品コード、商品名、バリエーション名、アーティストコード、単価、販売可能数の表示切替
    const category0 = [true, true, true, false, false, false, false, true, true] // SKU別用
    const category1 = [false, false, false, true, true, true, false, true, false] // 販売商品別用
    const category2 = [false, false, false, true, true, false, false, true, false] // 商品別用
    const category3 = [false, false, false, false, false, false, true, false, false] // アーティスト別用
    const skuCode = this.tableSetList.filter(row => row.itemKey === 'sku_code')
    const janCode = this.tableSetList.filter(row => row.itemKey === 'jan_code')
    const skuName = this.tableSetList.filter(row => row.itemKey === 'sku_name')
    const productCode = this.tableSetList.filter(row => row.itemKey === 'product_code')
    const productName = this.tableSetList.filter(row => row.itemKey === 'product_name')
    const variationName = this.tableSetList.filter(row => row.itemKey === 'variation_name')
    const artistCode = this.tableSetList.filter(row => row.itemKey === 'artist_code')
    const unitPrice = this.tableSetList.filter(row => row.itemKey === 'unit_price')
    const availableQuantity = this.tableSetList.filter(row => row.itemKey === 'available_quantity')
    if (this.conditions['category'].value === '0') {
      // SKU別
      skuCode[0].isAvailable = category0[0]
      skuCode[0].isActive = category0[0]
      janCode[0].isAvailable = category0[1]
      janCode[0].isActive = category0[1]
      skuName[0].isAvailable = category0[2]
      skuName[0].isActive = category0[2]
      productCode[0].isAvailable = category0[3]
      productCode[0].isActive = category0[3]
      productName[0].isAvailable = category0[4]
      productName[0].isActive = category0[4]
      variationName[0].isAvailable = category0[5]
      variationName[0].isActive = category0[5]
      artistCode[0].isAvailable = category0[6]
      artistCode[0].isActive = category0[6]
      unitPrice[0].isAvailable = category0[7]
      unitPrice[0].isActive = category0[7]
      availableQuantity[0].isAvailable = category0[8]
      availableQuantity[0].isActive = category0[8]

      // 検索条件の切り替え
      this.conditions['skuCode'].display = true
      this.conditions['exclusionSkuCode'].display = true
      this.conditions['skuName'].display = true
      this.conditions['productCode'].display = true
      this.conditions['exclusionProductCode'].display = true
      this.conditions['productName'].display = true
      this.conditions['skuCode'].canSelect = true
      this.conditions['exclusionSkuCode'].canSelect = true
      this.conditions['skuName'].canSelect = true
      this.conditions['productCode'].canSelect = true
      this.conditions['exclusionProductCode'].canSelect = true
      this.conditions['productName'].canSelect = true
    } else if (this.conditions['category'].value === '1') {
      // 販売商品別
      skuCode[0].isAvailable = category1[0]
      skuCode[0].isActive = category1[0]
      janCode[0].isAvailable = category1[1]
      janCode[0].isActive = category1[1]
      skuName[0].isAvailable = category1[2]
      skuName[0].isActive = category1[2]
      productCode[0].isAvailable = category1[3]
      productCode[0].isActive = category1[3]
      productName[0].isAvailable = category1[4]
      productName[0].isActive = category1[4]
      variationName[0].isAvailable = category1[5]
      variationName[0].isActive = category1[5]
      artistCode[0].isAvailable = category1[6]
      artistCode[0].isActive = category1[6]
      unitPrice[0].isAvailable = category1[7]
      unitPrice[0].isActive = category1[7]
      availableQuantity[0].isAvailable = category1[8]
      availableQuantity[0].isActive = category1[8]

      // 検索条件の切り替え
      this.conditions['skuCode'].display = true
      this.conditions['exclusionSkuCode'].display = true
      this.conditions['skuName'].display = true
      this.conditions['productCode'].display = true
      this.conditions['exclusionProductCode'].display = true
      this.conditions['productName'].display = true
      this.conditions['skuCode'].canSelect = true
      this.conditions['exclusionSkuCode'].canSelect = true
      this.conditions['skuName'].canSelect = true
      this.conditions['productCode'].canSelect = true
      this.conditions['exclusionProductCode'].canSelect = true
      this.conditions['productName'].canSelect = true
    } else if (this.conditions['category'].value === '2') {
      // 商品別
      skuCode[0].isAvailable = category2[0]
      skuCode[0].isActive = category2[0]
      janCode[0].isAvailable = category2[1]
      janCode[0].isActive = category2[1]
      skuName[0].isAvailable = category2[2]
      skuName[0].isActive = category2[2]
      productCode[0].isAvailable = category2[3]
      productCode[0].isActive = category2[3]
      productName[0].isAvailable = category2[4]
      productName[0].isActive = category2[4]
      variationName[0].isAvailable = category2[5]
      variationName[0].isActive = category2[5]
      artistCode[0].isAvailable = category2[6]
      artistCode[0].isActive = category2[6]
      unitPrice[0].isAvailable = category2[7]
      unitPrice[0].isActive = category2[7]
      availableQuantity[0].isAvailable = category2[8]
      availableQuantity[0].isActive = category2[8]

      // 検索条件の切り替え
      this.conditions['skuCode'].display = false
      this.conditions['exclusionSkuCode'].display = false
      this.conditions['skuName'].display = false
      this.conditions['productCode'].display = true
      this.conditions['exclusionProductCode'].display = true
      this.conditions['productName'].display = true
      this.conditions['skuCode'].canSelect = false
      this.conditions['exclusionSkuCode'].canSelect = false
      this.conditions['skuName'].canSelect = false
      this.conditions['productCode'].canSelect = true
      this.conditions['exclusionProductCode'].canSelect = true
      this.conditions['productName'].canSelect = true
    } else if (this.conditions['category'].value === '3') {
      // アーティスト別
      skuCode[0].isAvailable = category3[0]
      skuCode[0].isActive = category3[0]
      janCode[0].isAvailable = category3[1]
      janCode[0].isActive = category3[1]
      skuName[0].isAvailable = category3[2]
      skuName[0].isActive = category3[2]
      productCode[0].isAvailable = category3[3]
      productCode[0].isActive = category3[3]
      productName[0].isAvailable = category3[4]
      productName[0].isActive = category3[4]
      variationName[0].isAvailable = category3[5]
      variationName[0].isActive = category3[5]
      artistCode[0].isAvailable = category3[6]
      artistCode[0].isActive = category3[6]
      unitPrice[0].isAvailable = category3[7]
      unitPrice[0].isActive = category3[7]
      availableQuantity[0].isAvailable = category3[8]
      availableQuantity[0].isActive = category3[8]

      // 検索条件の切り替え
      this.conditions['skuCode'].display = true
      this.conditions['exclusionSkuCode'].display = true
      this.conditions['skuName'].display = true
      this.conditions['productCode'].display = false
      this.conditions['exclusionProductCode'].display = false
      this.conditions['productName'].display = false
      this.conditions['skuCode'].canSelect = true
      this.conditions['exclusionSkuCode'].canSelect = true
      this.conditions['skuName'].canSelect = true
      this.conditions['productCode'].canSelect = false
      this.conditions['exclusionProductCode'].canSelect = false
      this.conditions['productName'].canSelect = false
    }

    // 合計行の表示切替
    const sumUnitPrice = this.sumDisplayRows.filter(row => row.itemKey === 'unit_price')
    if (this.conditions['category'].value === '3') {
      // アーティスト別
      sumUnitPrice[0].isAvailable = false
      sumUnitPrice[0].isActive = false
    } else {
      sumUnitPrice[0].isAvailable = true
      sumUnitPrice[0].isActive = true
    }
  },
  methods: {
    displayTax: function () {
      const btn = document.getElementById('displayTax')
      if (this.isDisplayTax) {
        this.isDisplayTax = false
        btn.textContent = '税込計算'
      } else {
        this.isDisplayTax = true
        btn.textContent = '税抜計算'
      }

      const taxMode = (this.isDisplayTax ? 'Gross' : 'Net')
      const targetPriceList = [ ['単価', 'unit_price', 'unitPrice'], ['金額', 'amount', 'amount'], ['返品金額', 'return_amount', 'returnAmount'] ]
      // リロード対象のパラメータを設定する
      for (const tableSetItem of this.tableSetList) {
        for (const targetPriceItem of targetPriceList) {
          if (tableSetItem.itemKey === targetPriceItem[1]) {
            tableSetItem.path = 'node.' + targetPriceItem[2] + taxMode
            tableSetItem.label = this.isDisplayTax ? targetPriceItem[0] + '(税込)' : targetPriceItem[0] + '(税抜)'
          }
        }
      }

      return this.tableSetList.sort((a, b) => a.displayOrder < b.displayOrder ? -1 : 1)

    },
    // 合計算出
    sumData (sortedItems) {
      let sumUnitGross = 0
      let sumUnitNet = 0
      let sumOrderCnt = 0
      let sumQuantity = 0
      let sumAmountGross = 0
      let sumAmountNet = 0
      let sumReturnCnt = 0
      let sumReturnQty = 0
      let sumReturnAmountGross = 0
      let sumReturnAmountNet = 0

      for (const row of sortedItems) {
        sumUnitGross += row.node.unitPriceGross
        sumUnitNet += row.node.unitPriceNet
        sumOrderCnt += row.node.orderCnt
        sumQuantity += row.node.quantity
        sumAmountGross += row.node.amountGross
        sumAmountNet += row.node.amountNet
        sumReturnCnt += row.node.returnCnt
        sumReturnQty += row.node.returnQty
        sumReturnAmountGross += row.node.returnAmountGross
        sumReturnAmountNet += row.node.returnAmountNet
      }

      // 税抜/税込切り替え
      let dispSumUnit = (this.isDisplayTax ? sumUnitGross : sumUnitNet)
      let dipsSumAmount = (this.isDisplayTax ? sumAmountGross : sumAmountNet)
      let dispSumReturnAmount = (this.isDisplayTax ? sumReturnAmountGross : sumReturnAmountNet)

      // 格納データセット
      let sumData = [{
        sumUnitPrice: dispSumUnit.toLocaleString(),
        sumOrderCnt: sumOrderCnt.toLocaleString(),
        sumQuantity: sumQuantity.toLocaleString(),
        sumAmount: dipsSumAmount.toLocaleString(),
        sumReturnCnt: sumReturnCnt.toLocaleString(),
        sumReturnQty: sumReturnQty.toLocaleString(),
        sumReturnAmount: dispSumReturnAmount.toLocaleString()
      }]

      // アーティスト別の場合、合計 単価を非表示にする
      if (this.conditions['category'].value === '3') {
      }

      return sumData
    }
  }
}
</script>

<style scoped>
  .prefixTableRow .el-button {
    text-align: center;
    margin-bottom: 10px;
  }
  .prefixTableRow .el-button ::v-deep span {
    margin: 0px;
  }

  .base-list-page ::v-deep .description .cell .inner-cell div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }
</style>
